import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteDataContainer from 'containers/Data/AutoCompleteDataContainer';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import styles from './styles';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { connect } from 'react-redux';
import { createProductProperty } from 'store/actions/productProperties/createProductProperties';
import { fetchProperties } from 'store/actions/properties/fetchProperties';
import { reduxForm, Field, reset, change } from 'redux-form';

class ProductPropertiesCreate extends React.Component {
    submit = (formValues) => {
        const { createProductProperty, dispatch, form, productId } = this.props;

        if (utils.isEmpty(formValues)) {
            return null;
        }

        const refreshPage = formValues.addAnother || false;

        const formattedValues = {
            product_id: productId,
            property_id: formValues.property_id,
            priority: formValues.priority,
        };

        return new Promise((resolve) => {
            return createProductProperty({
                form: formattedValues,
                productId: productId,
                refresh: refreshPage,
                callback: function (response) {
                    if (response === 'error') {
                        return resolve();
                    }

                    dispatch(reset(form));
                    dispatch(change(form, 'addAnother', refreshPage));

                    resolve();
                },
            });
        });
    }

    render() {
        const { handleSubmit, pristine, resource, submitting, translate } = this.props;

        return (
            <div style={ styles.container }>
                <form onSubmit={ handleSubmit(this.submit) } >
                    <div>
                        <AutoCompleteDataContainer
                            action={ fetchProperties }
                            reference={ resource }
                        >
                            <Field
                                component={ RenderAutoCompleteInputField }
                                fullWidth={ true }
                                label={ translate('resources.products.fields.property_id') }
                                name='property_id'
                                style={ styles.formElement }
                                validate={ validations.required }
                            />
                        </AutoCompleteDataContainer>

                        <Field
                            component={ RenderTextInputField }
                            label={ translate('resources.products.fields.priority') }
                            name='priority'
                            style={ styles.formElement }
                            type='number'
                            validate={ validations.required }
                        />
                    </div>

                    <div style={ styles.buttons }>
                        <SubmitButton
                            disabled={ pristine || submitting }
                            loading={ submitting }
                        />

                        <Field
                            component={ RenderCheckBoxInputField }
                            label={ translate('actions.submit_add_another') }
                            name='addAnother'
                            style={ styles.checkbox }
                        />
                    </div>
                </form>
            </div>
        );
    }
}

ProductPropertiesCreate.propTypes = {
    createProductProperty: PropTypes.func.isRequired,
    dispatch: PropTypes.func,
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    productId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    resource: PropTypes.string,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

let HOCProductPropertiesCreate = reduxForm({
    form: 'product_properties_create',
})(ProductPropertiesCreate);

HOCProductPropertiesCreate = connect(
    null,
    {
        createProductProperty: createProductProperty,
    }
)(HOCProductPropertiesCreate);

export default translate(HOCProductPropertiesCreate);



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/create/ProductPropertiesCreate.js